import { h } from './pragma.mjs';

// YouTube playlist embed is loaded only after the user clicks the placeholder
// so that no third-party (YouTube/Google) connections are made until then.
const YOUTUBE_PLAYLIST_EMBED_URL =
    'https://www.youtube.com/embed?listType=playlist&list=PLeidu-ZsgUwJrOsCrX_GDQANjLIG6J5Si';

function loadYoutubePlaylist(event) {
    const button = event.currentTarget;
    const iframe = document.createElement('iframe');
    iframe.id = 'ytplayer';
    iframe.title = 'Instruktážní videa';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.loading = 'lazy';
    iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.src = `${YOUTUBE_PLAYLIST_EMBED_URL}&autoplay=1`;
    button.replaceWith(iframe);
    iframe.focus();
}

export default (aktivni) => {
    
    return (
      <gov-tabs-item id="oPortalu" label="O Portálu" default={aktivni}>
        <h1>O Portálu katastru a zeměměřictví</h1>
        <br />
        <h2 id="uzivatelska-podpora">Uživatelská podpora</h2>

        <p>
          Uživatelskou podporu zajišťuje helpdesk Českého úřadu zeměměřického
          a katastrálního.
        </p>

        <dl class="helpdesk-kontakty">
          <dt>
            <gov-icon class="helpdesk-kontakty__icon" type="basic" name="chat-left-text"></gov-icon>
            Kontaktní formulář
          </dt>
          <dd>
            <a href="https://podpora.cuzk.gov.cz/ehd/vytvorPozadavek?oblast=Port%C3%A1l%20katastru%20a%20zem%C4%9Bm%C4%9B%C5%99ictv%C3%AD">
              podpora.cuzk.gov.cz
            </a>
          </dd>

          <dt>
            <gov-icon class="helpdesk-kontakty__icon" type="basic" name="phone"></gov-icon>
            Telefon
          </dt>
          <dd>
            <a href="tel:+420284044455">+420 284 044 455</a>
          </dd>

          <dt>
            <gov-icon class="helpdesk-kontakty__icon" type="basic" name="envelope"></gov-icon>
            E-mail
          </dt>
          <dd>
            <a href="mailto:cuzk.helpdesk@cuzk.gov.cz">cuzk.helpdesk@cuzk.gov.cz</a>
          </dd>
        </dl>

        <h3>Provozní doba</h3>
        <table class="helpdesk-hodiny">
          <caption class="sr-only">Provozní hodiny helpdesku</caption>
          <tbody>
            <tr><th scope="row">Pondělí</th><td>8:00 – 17:00</td></tr>
            <tr><th scope="row">Úterý</th><td>8:00 – 14:00</td></tr>
            <tr><th scope="row">Středa</th><td>8:00 – 17:00</td></tr>
            <tr><th scope="row">Čtvrtek</th><td>8:00 – 14:00</td></tr>
            <tr><th scope="row">Pátek</th><td>8:00 – 12:00</td></tr>
          </tbody>
        </table>
        <br />
        <h3>Instruktážní videa</h3>
        <p>
          V návaznosti na spuštění Portálu katastru a zeměměřictví (Portál) byla
          vytvořena edukativní videa s praktickými ukázkami práce v Portálu.
          Tato videa byla umístěna na platformě youtube. V současné době jsou k
          dispozici tři videa:
        </p>
        <ol>
          <li>
            <a
              href="https://www.youtube.com/watch?v=yCnJ_TSx2Xo"
              target="_blank"
              rel="noopener noreferrer"
            >
              s obecnými informacemi o Portálu
            </a>
            ,
          </li>
          <li>
            <a
              href="https://www.youtube.com/watch?v=H36a9kqTsR0"
              target="_blank"
              rel="noopener noreferrer"
            >
              k zápisu stavby do katastru nemovitostí
            </a>
            ,
          </li>
          <li>
            <a
              href="https://www.youtube.com/watch?v=7C72u3NwmEs"
              target="_blank"
              rel="noopener noreferrer"
            >
              k návrhu na vklad do katastru nemovitostí
            </a>
            .
          </li>
        </ol>
        <br />
        <div class="responsive-video">
          <button
            type="button"
            class="video-facade"
            aria-label="Načíst přehrávač YouTube s instruktážními videi. Po kliknutí dojde k navázání spojení s youtube.com a souvisejícími službami Google."
            onClick={loadYoutubePlaylist}
          >
            <gov-icon class="video-facade__icon" type="basic" name="play-circle-fill" aria-hidden="true"></gov-icon>
            <span class="video-facade__title">Načíst přehrávač YouTube s instruktážními videi</span>
            <span class="video-facade__note">
              Kliknutím dojde k navázání spojení s youtube.com a souvisejícími službami Google.
            </span>
          </button>
        </div>
        <br />
        <br />
        <h2 id="prohlaseni-o-pristupnosti">Prohlášení o přístupnosti</h2>

        <p>
          Český úřad zeměměřický a katastrální (dále jen „ČÚZK“) se zavazuje k
          zpřístupnění svých webových stránek a aplikací v souladu se zákonem č.
          99/2019 Sb., o přístupnosti internetových stránek a mobilních aplikací
          a se změnou zákona č. 365/2000 Sb., o informačních systémech veřejné
          správy a o změně některých dalších zákonů, ve znění pozdějších
          předpisů (dále jen „zákon o přístupnosti“), kterým se transponuje
          směrnice Evropského parlamentu a Rady (EU) 2016/2102 ze dne 26. října
          2016 o přístupnosti internetových stránek a mobilních aplikací
          subjektů veřejného sektoru.
        </p>

        <p>
          Toto prohlášení o přístupnosti se vztahuje na internetovou aplikaci
          provozovanou na adrese{" "}
          <a href="https://portal.cuzk.gov.cz/">https://portal.cuzk.gov.cz/</a>
        </p>

        <h3>Stav souladu</h3>

        <p>
          Při tvorbě aplikace byla zohledněna přístupnost a bezbariérovost webu
          tak, aby co nejvíce splňovala zásady přístupnosti podle metodik WCAG
          Priority 1&2 (AA). Aplikace je částečně v souladu se zákonem č.
          99/2019 Sb., o přístupnosti internetových stránek a mobilních aplikací
          a o změně zákona č. 365/2000 Sb., o informačních systémech veřejné
          správy a o změně některých dalších zákonů, ve znění pozdějších
          předpisů. Zásady přístupnosti, které nejsou splněny, jsou uvedeny
          níže.
        </p>
        <h3>Výjimky z přístupnosti</h3>

        <p>
          <ul>
            <li>
              Každý netextový prvek nesoucí významové sdělení má svou textovou
              alternativu.
              <ul>
                <li>Výjimka: Zobrazování map nemá textovou alternativu.</li>
              </ul>
            </li>
          </ul>
          <br />

          <ul>
            <li>
              Informace sdělované prostřednictvím skriptů, objektů, appletů,
              kaskádových stylů, cookies a jiných doplňků na straně uživatele
              jsou dostupné i bez kteréhokoli z těchto doplňků.
              <ul>
                <li>Výjimka: Celá aplikace vyžaduje podporu cookies.</li>
                <li>Výjimka: Celá aplikace vyžaduje podporu JavaScriptu.</li>
              </ul>
            </li>
          </ul>

          <br />
          <ul>
            <li>
              Nová okna se otevírají jen v odůvodněných případech a uživatel je
              na to předem upozorněn.
              <ul>
                <li>Výjimka: Nápověda a mapa se vždy otevírá v novém okně.</li>
              </ul>
            </li>
          </ul>
        </p>
        <br />

        <h2 id="podminky-uzivani">Podmínky užívání aplikace a cookies</h2>
        <p>
          <i>Tato verze podmínek nabývá platnosti a účinnosti dne 1.2.2025.</i>
        </p>

        <p>
          Aplikaci Portál katastru a zeměměřictví (Portál), provozuje Český úřad
          zeměměřický a katastrální (Úřad).
        </p>

        <p>
          Aplikace je určena pro přípravu a odeslání podání na příslušný úřad
          resortu zeměměřictví a katastru v souladu s § 4 odst. 1 písm. d)
          zákona č. 12/2020 Sb., zákon o právu na digitální služby a o změně
          některých zákonů.
        </p>

        <p>
          Aplikace je určena výhradně pro interaktivní práci uživatelů, v
          případě aplikací třetích stran je možné se na Portál odkazovat.
          Aplikacím třetích stran se mohou zobrazovat informace v jiném rozsahu.
          Není povoleno jakékoli vytěžování údajů automatizovanými prostředky
          nebo získávání informací z Portálu pomocí automatizovaného
          zpracovávání informací (parsování výstupů apod.) z jiných systémů a
          aplikací. Úřad negarantuje dostupnost aplikace (SLA), nezveřejňuje
          specifikaci rozhraní aplikace, nezaručuje, že toto rozhraní nebude
          měněno a o případných změnách neuveřejňuje žádné předběžné informace.
        </p>

        <p>
          Užití údajů katastru nemovitostí získaných z Portálu v rozporu s 1
          odst. 2 katastrálního zákona a jejich další šíření v rozporu s § 53
          katastrálního zákona bude kvalifikováno jako přestupek podle § 57
          odst. 1 katastrálního zákona. Za takové jednání může být uložena
          pokuta až do výše 100 000 Kč. Shromažďování, zpracovávání a
          zveřejňování osobních údajů (jmen, příjmení a adres, příp. dat
          narození vlastníků nemovitostí – fyzických osob) může být
          kvalifikováno jako porušení povinností stanovených zákonem č. 110/2019
          Sb., o zpracování osobních údajů. Úřad při podezření na takovéto
          jednání upozorní Úřad pro ochranu osobních údajů. Podle § 61 a násl.
          zákona č. 110/2019 Sb. může Úřad pro ochranu osobních údajů za
          přestupek na úseku ochrany osobních údajů uložit pokutu až do výše 10
          000 000 Kč.
        </p>

        <p>
          Každý uživatel je povinen se seznámit s podmínkami užití Portálu a
          dodržovat je. V případě změny podmínek užití Portálu bude na takovou
          skutečnost upozorněno na úvodní stránce aplikace.
        </p>

        <p>
          Informace o způsobu zpracování osobních údajů jsou dostupné na adrese{" "}
          <a href="https://cuzk.gov.cz/cuzk/gdpr">
            https://cuzk.gov.cz/cuzk/gdpr
          </a>
          .
        </p>
        <p>
          Informace o ukládání dat ve Vašem zařízení jsou dostupné na stránce{" "}
          <a href="https://nahlizenidokn.cuzk.gov.cz/Napoveda/index.htm?context=60">
            https://nahlizenidokn.cuzk.gov.cz/Napoveda/index.htm?context=60
          </a>
          .
        </p>

        <h3>Jaké technické požadavky musí splňovat počítač?</h3>

        <p>
          Pro správnou funkčnost aplikace je vyžadována podpora Cookies. Pro
          funkčnost grafické části aplikace (zobrazování map) je navíc
          vyžadována podpora JavaScriptu. Mapy se otevírají v novém okně, proto
          je nutné mít vypnuté blokování nových oken pro doménu cuzk.gov.cz.
        </p>

        <p>
          Před zpřístupněním aplikace veřejnosti je její správná funkčnost
          aplikace testována na aktuálních verzích prohlížečů:
          <ul>
            <li>Google Chrome,</li>
            <li>Microsoft Edge,</li>
            <li>Mozilla Firefox.</li>
          </ul>
        </p>
        <p>
          Při problémech s aplikací nejprve:
          <ul>
            <li>
              zkontrolujte, zda nepoužíváte produkt tohoto typu, případně
              upravte jeho nastavení,
            </li>
            <li>vymažte cache (dočasné soubory) prohlížeče,</li>
            <li>
              zkuste vynutit nové načtení stránky stisknutím <kbd>Ctrl</kbd> +{" "}
              <kbd>F5</kbd>.
            </li>
          </ul>
        </p>

        <br />
      </gov-tabs-item>
    );
}